'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$GroupingId$() {
  this.c7j = null;
  this.c7k = false;
  this.c7h = null;
  this.c7i = false;
}
export { $c_Lpresto_types$GroupingId$ as $c_Lpresto_types$GroupingId$ };
$p = $c_Lpresto_types$GroupingId$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$GroupingId$;
/** @constructor */
function $h_Lpresto_types$GroupingId$() {
}
export { $h_Lpresto_types$GroupingId$ as $h_Lpresto_types$GroupingId$ };
$h_Lpresto_types$GroupingId$.prototype = $p;
$p.SO = (function() {
  if ((!this.c7k)) {
    this.c7j = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().j0;
    this.c7k = true;
  }
  return this.c7j;
});
$p.nK = (function() {
  if ((!this.c7i)) {
    this.c7h = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().dZ;
    this.c7i = true;
  }
  return this.c7h;
});
var $d_Lpresto_types$GroupingId$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$GroupingId$, "presto.types$GroupingId$", ({
  a0h: 1,
  D: 1
}));
export { $d_Lpresto_types$GroupingId$ as $d_Lpresto_types$GroupingId$ };
var $n_Lpresto_types$GroupingId$;
function $m_Lpresto_types$GroupingId$() {
  if ((!$n_Lpresto_types$GroupingId$)) {
    $n_Lpresto_types$GroupingId$ = new $c_Lpresto_types$GroupingId$();
  }
  return $n_Lpresto_types$GroupingId$;
}
export { $m_Lpresto_types$GroupingId$ as $m_Lpresto_types$GroupingId$ };
//# sourceMappingURL=presto.types$-Grouping-Id$.js.map
